import logo from "assets/images/brands/logo_converted.png";
import smLogo from "assets/images/brands/logo_converted.png";

export const clientName = "Maasgain Global";
export const developedBy = "Maasgain Global";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const companyName =  "Maasgain Global";
export const sidebarLogo = smLogo;
export const mainLogo = logo;
export const lightLogo = logo;
